// extracted by mini-css-extract-plugin
export var active = "_jt-2";
export var recordingDot = "_jt-1";
export var recordingIndicator = "_jt-0";